import {useState} from "react";
import {useLocation, useOutletContext, useParams} from "react-router-dom";
import {GobernanzaService} from "saneamiento/service";
import {gobernanza_view_adapter} from "saneamiento/model";
import {useNavigateWithReload} from "base/hooks";
import {EntityUpdatePanel} from "base/entity";
import {GobernanzaForm} from "../presentational/form";

const UpdateGobernanzaPanel = () => {
    const {codigo, section} = useParams();
    const location = useLocation();
    const baseLocationPath = location.pathname.split(section)[0];

    const [error, setError] = useState("");
    const navigate = useNavigateWithReload();

    let gobernanza;
    [gobernanza] = useOutletContext();

    const handleSubmit = gobernanza => {
        GobernanzaService.update(gobernanza_view_adapter({...gobernanza}))
            .then(() => {
                navigate(baseLocationPath, true);
            })
            .catch(error => {
                setError(error);
            });
    };

    const handleFormCancel = () => {
        navigate(baseLocationPath);
    };

    return (
        <EntityUpdatePanel
            form={
                <GobernanzaForm
                    gobernanza={gobernanza}
                    codigoConcello={codigo}
                    updatedSection={section}
                    onSubmit={handleSubmit}
                    onCancel={handleFormCancel}
                />
            }
            title="Modificar gobernanza"
            error={error}
            onCancel={handleFormCancel}
        />
    );
};

export default UpdateGobernanzaPanel;
